import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import {
  WaysToUseMailroomStaticsMainWrapper,
  WaysToUseMailroomStaticsWrapper,
  WaysToUseMailroomStaticsContainer,
  WaysToUseMailroomStaticsDescriptionInnerContainer,
} from "./waysToUseMailroomStatics.style"

const WaysToUseMailroomStatics = ({ introData, backgroundColor}) => {
  return (
    <WaysToUseMailroomStaticsMainWrapper backgroundColor={backgroundColor}>
    <WaysToUseMailroomStaticsWrapper>
      <>
        <WaysToUseMailroomStaticsDescriptionInnerContainer>
          <p className="heading">Why PackageX Mailroom?</p>
          {introData.map(({ description }) => (
            <span
              className="description"
              dangerouslySetInnerHTML={{
                __html: description,
              }}
            />
          ))}
        </WaysToUseMailroomStaticsDescriptionInnerContainer>
      </>
        <WaysToUseMailroomStaticsContainer>
            <>
              <StaticImage src="../../../images/Industries/mailroom-statistics-image.png" alt="mailroom industry image" 
              placeholder="blurred"
              loading="lazy"/>
            </>
        </WaysToUseMailroomStaticsContainer>
    </WaysToUseMailroomStaticsWrapper>
    </WaysToUseMailroomStaticsMainWrapper>
  )
}

export default WaysToUseMailroomStatics
